export default "<r-application-signature #applicationSignatureRef></r-application-signature>\n";